import * as React from 'react';

import {FeatureGateModal} from 'shells/billing/feature-gate/feature-gate-modal';
import type {FeatureName} from 'shells/billing/feature-gate/features-list';

import type {LimitedType} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {useGetLimitsByType} from '../use-get-limits-by-type';

type Props = {
    title: string;
    description: string;
    bullets: string[];
    feature: FeatureName;
    icon?: React.ReactNode;
    onClose: () => void;
    isOpen: boolean;
    shouldShowButton?: boolean;
    limitsType?: LimitedType;
};

export function FeatureGateModalWrapper(props: Props) {
    const {limitsType, ...restProps} = props;
    const {user} = useGetSessionUser();
    const {limits} = useGetLimitsByType(limitsType, !limitsType);
    const userCanAccessBilling = Boolean(user && user.permissions.canAccessBilling);

    if (!user) {
        return null;
    }

    return (
        <FeatureGateModal
            analyticsClient={analyticsClient}
            isAdmin={userCanAccessBilling}
            upgradePlanName={
                limits && limits.upgradePlanName !== limits.currentPlanName
                    ? limits.upgradePlanName
                    : null
            }
            {...restProps}
        />
    );
}
